import { CompetitionPayload } from 'models/endpoints-payload'
import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_IK: string

const competitionSubscribe = (payload: CompetitionPayload): Promise<void> => {
  return promiseWrapper<null, CompetitionPayload>(`${USER_BASE_URL_IK}/api/public/cmsEmailSubscribe`, 'POST', payload)
}

export default competitionSubscribe
